// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M12 13.4L7.1 18.3Q6.82 18.58 6.4 18.58T5.7 18.3 5.42 17.6 5.7 16.9L10.6 12 5.7 7.1Q5.42 6.82 5.42 6.4T5.7 5.7 6.4 5.42 7.1 5.7L12 10.6 16.9 5.7Q17.18 5.42 17.6 5.42T18.3 5.7 18.58 6.4 18.3 7.1L13.4 12 18.3 16.9Q18.58 17.18 18.58 17.6T18.3 18.3 17.6 18.58 16.9 18.3Z"/>';

/** Close (actions). */
const icon: IconData = {
  id: "close",
  name: "Close",
  category: "actions",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M6.4 19L5 17.6 10.6 12 5 6.4 6.4 5 12 10.6 17.6 5 19 6.4 13.4 12 19 17.6 17.6 19 12 13.4Z"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M12 13.4L7.1 18.3Q6.82 18.58 6.4 18.58T5.7 18.3 5.42 17.6 5.7 16.9L10.6 12 5.7 7.1Q5.42 6.82 5.42 6.4T5.7 5.7 6.4 5.42 7.1 5.7L12 10.6 16.9 5.7Q17.18 5.42 17.6 5.42T18.3 5.7 18.58 6.4 18.3 7.1L13.4 12 18.3 16.9Q18.58 17.18 18.58 17.6T18.3 18.3 17.6 18.58 16.9 18.3Z"/></g><path d="M12 13.4L7.1 18.3Q6.82 18.58 6.4 18.58T5.7 18.3 5.42 17.6 5.7 16.9L10.6 12 5.7 7.1Q5.42 6.82 5.42 6.4T5.7 5.7 6.4 5.42 7.1 5.7L12 10.6 16.9 5.7Q17.18 5.42 17.6 5.42T18.3 5.7 18.58 6.4 18.3 7.1L13.4 12 18.3 16.9Q18.58 17.18 18.58 17.6T18.3 18.3 17.6 18.58 16.9 18.3Z"/>',
    },
  },
  animation: () => import("../animations/close.js"),
};

export default icon;
